/**
 * Service for fetching expedited orders and nearby drivers.
 * By default it calls the backend gateway at
 * `/location-mgmt/admin/driver/expeditedlocations`.
 * Falls back to an in-memory mock when the request fails (useful in development).
 */
import http from "./httpService";

/**
 * Fetch expedited orders (AwaitingSelection status) with nearby drivers from the backend.
 * The upstream path configured in the API gateway is `/location-mgmt/admin/driver/expeditedlocations`.
 * Backend returns paginated expedited orders with nearby drivers already attached.
 *
 * @param {number} pageNumber - Current page number (default: 1)
 * @param {number} pageSize - Number of records per page (default: 50)
 * @param {number} maxDriversPerOrder - Maximum drivers to return per order (default: 5)
 * @returns {Promise<Object>} Paginated result { page: [...], totalRecords }
 * @throws {Error} If API request fails; no fallback to mock data
 */
export const getExpeditedOrders = async (pageNumber = 1, pageSize = 50, maxDriversPerOrder = 5) => {
  try {
    const {
      data: { data },
    } = await http.get(`/location-mgmt/admin/driver/expeditedlocations`, {
      params: {
        PageNumber: pageNumber,
        PageSize: pageSize,
        MaxDriversPerOrder: maxDriversPerOrder,
      },
    });
    return data;
  } catch (err) {
    // Propagate error so UI shows empty state instead of mock data
    // eslint-disable-next-line no-console
    console.error("Failed to fetch expedited orders from API:", err?.message || err);
    throw err;
  }
};

export default getExpeditedOrders;
